(() => {
  const root = document.querySelector('[data-buttercream-root]');
  if (!root) return;

  const navToggle = root.querySelector('[data-nav-toggle]');
  const nav = root.querySelector('[data-nav]');
  if (navToggle && nav) {
    const setNavOpen = (open) => {
      nav.classList.toggle('is-open', open);
      navToggle.classList.toggle('is-open', open);
      navToggle.setAttribute('aria-expanded', String(open));
      navToggle.setAttribute('aria-label', open ? 'Close site menu' : 'Open site menu');
    };

    navToggle.addEventListener('click', (event) => {
      event.stopPropagation();
      setNavOpen(!nav.classList.contains('is-open'));
    });

    nav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => setNavOpen(false));
    });

    document.addEventListener('click', (event) => {
      if (!nav.classList.contains('is-open')) return;
      if (!nav.contains(event.target) && !navToggle.contains(event.target)) setNavOpen(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && nav.classList.contains('is-open')) {
        setNavOpen(false);
        navToggle.focus();
      }
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 760) setNavOpen(false);
    });
  }

  const eventDate = root.querySelector('[data-event-date]');
  if (eventDate) {
    const now = new Date();
    const localDate = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10);
    eventDate.min = localDate;
  }

  const dialog = root.querySelector('[data-size-guide-dialog]');
  const openDialog = root.querySelector('[data-size-guide-open]');
  const closeDialog = root.querySelector('[data-size-guide-close]');
  if (dialog && openDialog) {
    openDialog.addEventListener('click', () => {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    });
  }
  if (dialog && closeDialog) closeDialog.addEventListener('click', () => dialog.close());
  if (dialog) {
    dialog.addEventListener('click', (event) => {
      const rect = dialog.getBoundingClientRect();
      const inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside) dialog.close();
    });
  }

  root.querySelectorAll('[data-inspiration-file]').forEach((input) => {
    input.addEventListener('change', () => {
      const preview = input.closest('.upload-card')?.querySelector('[data-upload-preview]');
      const file = input.files?.[0];
      if (!preview) return;
      if (!file) {
        preview.hidden = true;
        preview.removeAttribute('src');
        return;
      }
      const url = URL.createObjectURL(file);
      preview.src = url;
      preview.hidden = false;
      preview.onload = () => URL.revokeObjectURL(url);
    });
  });

  const allergyBoxes = Array.from(root.querySelectorAll('[data-allergy-checkbox]'));
  const noAllergyBox = root.querySelector('[data-no-allergy]');
  allergyBoxes.forEach((box) => {
    box.addEventListener('change', () => {
      if (!box.checked) return;
      if (box === noAllergyBox) {
        allergyBoxes.forEach((other) => { if (other !== box) other.checked = false; });
      } else if (noAllergyBox) {
        noAllergyBox.checked = false;
      }
    });
  });

  const form = root.querySelector('#CakeInquiryForm');
  const photoSection = root.querySelector('[data-photo-section]');
  const hiddenUploadUrls = root.querySelector('[data-upload-urls]');
  const uploadStatus = root.querySelector('[data-upload-status]');
  const submitButton = root.querySelector('[data-submit-button]');
  let uploadComplete = false;

  async function uploadInspirationFiles(files, endpoint) {
    const payload = new FormData();
    files.forEach((file, index) => payload.append(`file_${index + 1}`, file, file.name));
    payload.append('source', 'The ButterCream Social cake inquiry');

    const response = await fetch(endpoint, { method: 'POST', body: payload });
    if (!response.ok) throw new Error(`Upload failed (${response.status})`);
    const data = await response.json();
    const urls = Array.isArray(data.urls) ? data.urls : [];
    if (!urls.length) throw new Error('Upload endpoint did not return any URLs. Expected JSON like {"urls":["https://..."]}.');
    return urls;
  }

  if (form) {
    form.addEventListener('submit', async (event) => {
      if (uploadComplete) return;

      const mode = photoSection?.dataset.uploadMode;
      const endpoint = photoSection?.dataset.uploadEndpoint?.trim();
      const files = Array.from(root.querySelectorAll('[data-inspiration-file]'))
        .map((input) => input.files?.[0])
        .filter(Boolean);

      if (mode !== 'endpoint' || files.length === 0) return;

      event.preventDefault();

      if (!endpoint) {
        if (uploadStatus) uploadStatus.textContent = 'Direct photo upload is not connected yet. Please paste public inspiration links below, or add an upload endpoint in the theme editor.';
        photoSection?.querySelector('[data-link-fallback] input')?.focus();
        return;
      }

      try {
        submitButton?.classList.add('is-loading');
        if (submitButton) submitButton.disabled = true;
        if (uploadStatus) uploadStatus.textContent = 'Uploading inspiration photos…';

        const urls = await uploadInspirationFiles(files, endpoint);
        if (hiddenUploadUrls) hiddenUploadUrls.value = urls.join('\n');
        if (uploadStatus) uploadStatus.textContent = 'Photos uploaded. Sending your inquiry…';
        uploadComplete = true;
        form.submit();
      } catch (error) {
        if (uploadStatus) uploadStatus.textContent = `${error.message} You can use the inspiration link fields instead.`;
        submitButton?.classList.remove('is-loading');
        if (submitButton) submitButton.disabled = false;
      }
    });
  }

  const successMessage = root.querySelector('[data-success-message]');
  if (successMessage) {
    setTimeout(() => {
      successMessage.focus({ preventScroll: true });
      document.querySelector('#inquiry')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 50);
  }
})();
